import React, { Component } from 'react';

import Modal from "react-bootstrap/Modal";
import {setAvatar} from "../../actions/actions";
import {connect} from "react-redux";

import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import API from "../../lib/api";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class AvatarChoose extends Component {

    constructor(props) {

        super(props);
        this.state={
            folder:[],
            isLoading: true,
            cat:"",
            name:""
        }

        this.selectAvatar=this.selectAvatar.bind(this);
        this.setAvatar=this.setAvatar.bind(this);


    }
    async  componentDidMount(){

        var formData = new FormData();
        formData.append("id", this.props.chatprop.modal.data.id);

        await API.post("agents/choose-avatar", formData).then((response) => {
            if (response.status === 200) {
                if(typeof response.data.message.success!=="undefined"){
                    if(typeof response.data.message.data!=="undefined") {
                        var folderData = {};
                        var data = response.data.message.data;
                        Object.keys(data).forEach(key => {
                            folderData[key] = data[key];
                        });

                        var dataArr = [];
                        for (var values in folderData) {
                            dataArr.push(folderData[values]);
                        }

                        this.setState({
                            folder:dataArr,
                            isLoading:false
                        });
                        console.log(this.state.folder);
                    }
                }

            }
        });
    }

    setAvatar(e){
        this.props.dispatch(setAvatar(this.state.cat,this.state.name,this.props.chatprop.modal.data.id));
    }
    selectAvatar(e,cat,name){

        this.setState({
            cat:cat,
            name:name
        })
    }

    render() {
        const { t } = this.props

        const { isLoading,folder } = this.state;

        if (isLoading) {
            return <div className="App">Loading...</div>;
        }

        return (

            <>

                <Modal.Header closeButton>
                    <Modal.Title>Pick profile picture</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                        <div className="settings-tab my-4">
                        <nav>
                        <Tabs defaultActiveKey={folder[0].key}>

                            {folder.map(key=>{
                               return  <Tab eventKey={key.key} title={key.title}>
                                   <div className="avatar-container">
                                       {key.files.map(key2=> {
                                           return  <div className="avatar-list-div">

                                                <img src={process.env.REACT_APP_SERVICE+key2.path}
                                                     onClick={e=>this.selectAvatar(e, key.title,key2.name)}
                                                     className= {"i " + (this.state.name==key2.name ? 'activeAvatar' : '')}
                                                />

                                       </div>
                                       })}
                                   </div>
                                </Tab>

                            })}


                        </Tabs>
                        </nav>
                        </div>

                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="chat-button chat-button-success ml-1 "
                            onClick={e=>this.setAvatar(e)}
                    >
                        <span>Set profile picture</span>
                    </button>
                </Modal.Footer>
            </>

        );
    }
}

export default AvatarChoose;
